import React, {useState, useContext} from 'react'
import {AppContext} from '../context/AppContext'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import axios from 'axios'
import { useLocation } from 'react-router'
import styled from 'styled-components'

export const CheckoutForm = ({secret}) => {
  const {appState, appDispatch} = useContext(AppContext)
  
  const stripe = useStripe()
  const elements = useElements()
  const location = useLocation()

  const [message, setMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!stripe || !elements) {
      return
    }

    setIsLoading(true)

    stripe.confirmCardPayment(secret,{
      payment_method: {
        card: elements.getElement(CardElement),
      },
    })
    .then(async (result) => {
      if (result.error) {
        setMessage(result.error.message)
        setIsLoading(false)
      } else {
        const verifyData = new FormData()
        verifyData.append('productId', appState.course.id)
        verifyData.append('pid', result.paymentIntent.id)
        verifyData.append('clientSecret', secret)
        axios.post(appState.envVars.STRIPE_CONFIRM_API, verifyData, {
          headers: {
            'X-WP-Nonce': window.ttnonce || window.TTI_REST_NONCE
          }
        })
        .then(response => {
          if(response.data) {
            appDispatch({type: 'setCoursePurchased', isCoursePurchased: true})
            const now = new Date()
            const mHours = now.getHours()
            let hours = mHours
            let tod = "am"
            if(mHours === "0") {
              hours = "12"
            } else if(mHours > "12") {
              hours = mHours - 12
              tod = "pm"
            }
            const time = hours + ':' + now.getMinutes() + ':' + now.getSeconds() + ' ' + tod
            appDispatch({type: 'purchaseCourse', time: time})
            setMessage(null)
            setIsLoading(false)
          }
          else {
            setMessage('Something went wrong. Please try again.')
            setIsLoading(false)
            location.reload()
          }
        })
        .catch(err => {
          console.log("Error", err)
          setMessage('Something went wrong. Please try again.')
          setIsLoading(false)
          location.reload()
        })
      }
    })
  }
  return (
    <StyledForm onSubmit={handleSubmit}>
      {message && (
        <ErrorMessage>{message}</ErrorMessage>
      )}
      <CardElement />
      <PurchaseButton type='submit' disabled={!stripe} className="button">
        Get Course
      </PurchaseButton>
      {isLoading && <div className="tt-loader"></div>}
    </StyledForm>
  )
}

const ErrorMessage = styled.p`
  font-size: 0.6rem;
  text-align: center;
`

const StyledForm = styled.form`
  width: 100%;
  margin-top: 1rem;

  .StripeElement {
    width: 100%;
    margin-bottom: 1rem;
    border: solid 1px ${({theme}) => theme.text};
    border-radius: 5px;
    padding: 0.5rem;
  }
`

const PurchaseButton = styled.button`
  margin-bottom: 0;
`